//import React,{useState} from 'react';

import React, { useState } from "react";
import Chart from "react-apexcharts";
import Header from "./headerchart";

import Donutchart from "./donutchart";
const mql = window.matchMedia(`(min-width: 425px)`);

const ReportCreator = ({
  data,
  charHeight = "450",
  stacked = false,
  type = "bar",
  labelposition = "center",
  palette = "palette4",
  onclick,
  chkoption = true,
}) => {
  const [value, setValue] = useState(type);

  const lotaders = mql.matches;
  //console.log(lotaders);

  if (!data) return <div></div>;
  const yLabels = data.yLabels;
  const series = data.series;
  const header = data.headers;

  //const stacked = data.stacked

  //console.log(type)
  const handleOnclick = (label, id) => {
    onclick(label, id);
    //console.log(label,id)
  };
  const handleChange = (event) => {
    setValue(event);
  };

  const options = {
    chart: {
      type: value,
      height: 350,
      stacked: stacked,
      toolbar: {
        show: true,

        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,

          customIcons: [],
        },
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: ",",
            headerCategory: "category",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
        },
        autoSelected: "zoom",
      },

      events: {
        dataPointSelection: function (event, chartContext, config) {
          // console.log(config.w.config.series[config.seriesIndex].data[config.dataPointIndex])
          handleOnclick(
            config.w.config.xaxis.categories[config.dataPointIndex],
            config.seriesIndex
          );
          //  console.log(config.w.config.xaxis.categories[config.dataPointIndex],config.seriesIndex)
          // console.log(config.seriesIndex);
          // console.log(config.w.config.labels[config.dataPointIndex])
          // console.log('event',event)
          // console.log('chartContext',chartContext)
          //  console.log('config',config)
          // console.log(config.w.config.labels[config.dataPointIndex])
          // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
        },
        click(event, chartContext, config) {
          // console.log(config.seriesIndex);
          // console.log(config.dataPointIndex);
        },
      },
    },

    stroke: {
      width: 1,
      curve: "smooth",
    },
    responsive: [
      {
        breakpoint: 1000,
        options: {
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],

    plotOptions: {
      bar: {
        position: "top", // top, center, bottom
        background: "transparent",
        horizontal: false,
        dataLabels: {
          position: labelposition, // top, center, bottom
          offset: 0,
        },
        startAngle: 0,
        expandOnClick: true,
        offsetX: 0,
        offsetY: 0,
        customScale: 1,
      },

      pie: {
        startAngle: 0,
        expandOnClick: true,
        offsetX: 0,
        offsetY: 0,
        customScale: 1,
        dataLabels: {
          offset: 0,
          minAngleToShowLabel: 10,
        },
        donut: {
          size: "65%",
          background: "transparent",
          labels: {
            show: false,
            name: {
              show: true,
              fontSize: "22px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              color: undefined,
              offsetY: -10,
              formatter: function (val) {
                return val;
              },
            },
            value: {
              show: true,
              fontSize: "16px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              color: undefined,
              offsetY: 16,
              formatter: function (val) {
                return val;
              },
            },
            total: {
              show: false,
              showAlways: false,
              label: "Total",
              fontSize: "22px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              color: "#373d3f",
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => {
                  return a + b;
                }, 0);
              },
            },
          },
        },
      },
    },

    legend: {
      position: "bottom",
    },

    theme: {
      mode: "light",
      palette: palette,
      monochrome: {
        enabled: false,
        color: "#255aee",
        shadeTo: "light",
        shadeIntensity: 0.65,
      },
    },

    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val;
      },
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#304758"],
      },
    },
    xaxis: {
      categories: yLabels,
      // position: 'top',
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        fill: {
          type: "gradient",
          gradient: {
            colorFrom: "#D8E3F0",
            colorTo: "#BED1E6",
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          },
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: true,
      },
      labels: {
        show: true,
        formatter: function (val) {
          return val;
        },
      },

      tooltip: {
        enabled: true,
      },
    },
    title: {
      floating: true,
      offsetY: 330,
      align: "center",
      style: {
        color: "#444",
      },
    },
  };

  if (yLabels && yLabels.length == 0 && series.length == 0) {
    return;
  }

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-header text-center">
            <div className="row">
              <div className="col-sm-6 col-xs-12">{header}</div>
              {chkoption && (
                <div className="col-sm-6 col-xs-12">
                  <Header onChange={handleChange} />
                </div>
              )}
            </div>
          </div>
          <div className="card-body text-center">
            {value === "pie" ? (
              series.length > 1 ? (
                <div className="row">
                  <div className="col-6">
                    <Donutchart labels={yLabels} donutData={series[0].data} />
                  </div>

                  <div className="col-6">
                    <Donutchart labels={yLabels} donutData={series[1].data} />
                  </div>
                </div>
              ) : (
                <Donutchart labels={yLabels} donutData={series[1].data} />
              )
            ) : (
              series.length > 0 && (
                <Chart
                  options={options}
                  series={series}
                  type={value}
                  height={charHeight}
                />
              )
            )}
            {series.length === 0 && (
              <span className="text-muted">ไม่มีข้อมูล</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportCreator;
